import { LIMPAR_CIDADE_SELECIONADA, SELECIONAR_CIDADE } from '../../actions/types'

const initialState = undefined
const itemInicial = { nome: '', uf: null }

export default function reducerCidade (state = itemInicial, action = initialState) {
  switch (action.type) {
    case SELECIONAR_CIDADE: {
      return action.payload;
    }

    case LIMPAR_CIDADE_SELECIONADA: {
      return itemInicial;
    }

    default: {
      return state
    }
  }
}
